import { Col, Row } from "antd";
import dayjs from "dayjs";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdOutlineCake,
  MdOutlineFreeCancellation,
  MdPinDrop,
} from "react-icons/md";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { ANSET_SUBSCRIPTION_FORM_KEYS, DATE_FORMAT } from "utils/constants";

const Terminal = ({ setPercent, isFieldRequired, initialValues, bindField }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const BLOCK = t("ANSET_SUBSCRIPTION.ADDITIONAL_INFORMATION", {
    returnObjects: true,
  });

  const imeiPath = "project.fields.imei";
  const imeiField = bindField(imeiPath, {
    label: BLOCK.TERMINAL.FIELDS.IMEI.LABEL,
    required: isFieldRequired(imeiPath),
    onBlur: () => setPercent(initialValues),
  });

  const serialNumberPath = "project.fields.serialNumber";
  const serialNumberField = bindField(serialNumberPath, {
    label: BLOCK.TERMINAL.FIELDS.SERIAL_NUMBER.LABEL,
    required: isFieldRequired(serialNumberPath),
    onBlur: () => setPercent(initialValues),
  });

  const purchaseDatePath = "project.fields.purchaseDate";
  const purchaseDateField = bindField(purchaseDatePath, {
    label: BLOCK.TERMINAL.FIELDS.PURCHASE_DATE.LABEL,
    required: isFieldRequired(purchaseDatePath),
    onChange: () => setPercent(initialValues),
    onBlur: () => setPercent(initialValues),
  });

  const purchasePlacePath = "project.fields.purchasePlace";
  const purchasePlaceField = bindField(purchasePlacePath, {
    label: BLOCK.TERMINAL.FIELDS.PURCHASE_PLACE.LABEL,
    required: isFieldRequired(purchasePlacePath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${ANSET_SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.TERMINAL}-section`}
    >
      <Form
        type="vertical"
        title={BLOCK.TERMINAL.TITLE}
        subtitle={BLOCK.TERMINAL.SUBTITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={imeiField.path}
              label={imeiField.label}
              required={imeiField.required}
              disabled={imeiField.disabled}
            >
              {(field) => (
                <Input
                  placeholder={BLOCK.TERMINAL.FIELDS.IMEI.PLACEHOLDER}
                  label={imeiField.label}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={imeiField.defaultValue}
                  {...field}
                  onChange={imeiField.onChange}
                  onBlur={imeiField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={serialNumberField.path}
              label={serialNumberField.label}
              required={serialNumberField.required}
              disabled={serialNumberField.disabled}
            >
              {(field) => (
                <Input
                  placeholder={BLOCK.TERMINAL.FIELDS.SERIAL_NUMBER.PLACEHOLDER}
                  label={serialNumberField.label}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={serialNumberField.defaultValue}
                  {...field}
                  onChange={serialNumberField.onChange}
                  onBlur={serialNumberField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={purchaseDateField.path}
              label={purchaseDateField.label}
              required={purchaseDateField.required}
              disabled={purchaseDateField.disabled}
            >
              {(field) => (
                <Input
                  label={purchaseDateField.label}
                  placeholder={BLOCK.TERMINAL.FIELDS.PURCHASE_DATE.PLACEHOLDER}
                  icon={<MdOutlineCake size={16} />}
                  type="date"
                  variant="simple"
                  disabledDate={(current) =>
                    current &&
                    (current > dayjs() || current < dayjs().add(-3, "y"))
                  }
                  defaultValue={dayjs()}
                  value={
                    get(initialValues, purchaseDatePath)
                      ? dayjs(get(initialValues, purchaseDatePath))
                      : null
                  }
                  format={DATE_FORMAT}
                  {...field}
                  onChange={purchaseDateField.onChange}
                  onBlur={purchaseDateField.onBlur}
                />
              )}
            </FormField>
          </Col>
          <Col lg={24} xs={24}>
            <FormField
              path={purchasePlaceField.path}
              label={purchasePlaceField.label}
              required={purchasePlaceField.required}
              disabled={purchasePlaceField.disabled}
            >
              {(field) => (
                <Input
                  placeholder={BLOCK.TERMINAL.FIELDS.PURCHASE_PLACE.PLACEHOLDER}
                  label={purchasePlaceField.label}
                  icon={<MdPinDrop size={16} />}
                  defaultValue={purchasePlaceField.defaultValue}
                  {...field}
                  onChange={purchasePlaceField.onChange}
                  onBlur={purchasePlaceField.onBlur}
                />
              )}
            </FormField>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Terminal;
